import { Component } from '@angular/core';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ContentHeaderComponent, IContentHeaderConfig } from 'app/shared/components/molecules';
import { ButtonStyle } from 'app/shared/enums';
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  imports: [ContentHeaderComponent, MatAccordion, MatExpansionModule, MatIcon, TranslateModule],
})
export class SupportComponent {
  public openMailto(): void {
    window.location.href = 'mailto:support@yardnexus.com?subject=Support%20Request';
  }

  public openSupportRequest(): void {
    window.open('https://yardnexus.freshdesk.com', '_blank');
  }

  public headerConfig: IContentHeaderConfig = {
    buttons: [
      {
        text: 'support.submitSupportTicketButton',
        style: ButtonStyle.FILLED,
        action: this.openSupportRequest.bind(this),
      },
      {
        text: 'support.contactSupportButton',
        style: ButtonStyle.FILLED,
        action: this.openMailto.bind(this),
      },
    ],
  };
}
